<template>
  <div>
    <el-form :model="value" ref="formRef" :rules="formRules" label-suffix=":" label-width="100px">
      <el-row :gutter="24">
        <el-col :span="8">
          <el-form-item label="车场名称" prop="spaceId">
            <el-select
              v-model="value.spaceId"
              style="width: 100%"
              placeholder="请选择"
              disabled
              @change="projectIdChange"
            >
              <el-option
                v-for="item in spaceList"
                :key="item.id"
                :label="item.title"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="车牌号" prop="carNo">
            <el-input
              clearable
              v-model="value.carNo"
              placeholder="请输入车牌号"
              @blur="carNoBlur"
              maxlength="20"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="区域名称" prop="regions">
            <avue-input-tree
              style="width: 100%"
              :props="treeRegionProps"
              v-model="value.regions"
              placeholder="请选择区域"
              type="tree"
              multiple
              checkStrictly
              :dic="regionList"
            ></avue-input-tree>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="客户姓名" prop="customerName">
            <el-input
              clearable
              v-model="value.customerName"
              placeholder="请输入客户姓名"
              maxlength="20"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="客户手机" prop="customerPhone">
            <el-input
              clearable
              v-model="value.customerPhone"
              placeholder="请输入客户手机"
              maxlength="20"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="车辆类别" prop="driverType">
            <el-select
              v-model="value.driverType"
              style="width: 100%"
              placeholder="请选择车辆类别"
              @change="driverTypeChange"
            >
              <el-option
                v-for="item in carCategoryList"
                :key="item.dictKey"
                :label="item.dictValue"
                :value="item.dictKey"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="车辆类型" prop="carType">
            <el-select
              v-model="value.carType"
              style="width: 100%"
              placeholder="请选择车辆类型"
              @change="carTypeChange"
            >
              <el-option
                v-for="item in carTypeList"
                :key="item.dictKey"
                :label="item.dictValue"
                :value="item.dictKey"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="收费套餐" prop="ruleId">
            <el-select
              v-model="value.ruleId"
              style="width: 100%"
              placeholder="请选择收费套餐"
              :disabled="carRuleDisabled"
              @change="ruleIdChange"
            >
              <el-option
                v-for="item in ruleList"
                :key="item.id"
                :label="item.setmealName"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="租赁起期" prop="buyStartTime">
            <el-date-picker
              v-model="value.buyStartTime"
              style="width: 100%"
              value-format="yyyy-MM-dd 00:00:00"
              align="right"
              type="date"
              placeholder="选择租赁起期"
              @change="buyStartTimeChange"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="续租时长" prop="cycleNum">
            <el-select
              v-model="value.cycleNum"
              style="width: 100%"
              placeholder="请选择续租时长"
              @change="cycleNumChange"
            >
              <el-option
                v-for="item in cycleNumList"
                :key="item.dictKey"
                :label="item.dictValue"
                :value="item.dictKey"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="租赁止期" prop="buyEndTime">
            <el-date-picker
              v-model="value.buyEndTime"
              style="width: 100%"
              value-format="yyyy-MM-dd 23:59:59"
              disabled
              align="right"
              type="date"
              placeholder="选择租赁止期"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="优惠规则" prop="discountId">
            <el-select
              v-model="value.discountId"
              style="width: 100%"
              placeholder="请选择优惠规则"
              :disabled="discountRuleDisabled"
              @change="discountIdChange"
            >
              <el-option
                v-for="item in discountRuleList"
                :key="item.id"
                :label="item.discountName"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="应收金额" prop="shouldMoney">
            <el-input
              clearable
              v-model="value.shouldMoney"
              placeholder=""
              disabled
              maxlength="20"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="优惠金额" prop="cutMoney">
            <el-input
              clearable
              v-model="value.cutMoney"
              disabled
              placeholder=""
              maxlength="20"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="实收金额" prop="payMoney">
            <el-input
              clearable
              disabled
              v-model="value.payMoney"
              placeholder=""
              maxlength="20"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="备注" prop="remark">
            <el-input
              clearable
              v-model="value.remark"
              type="textarea"
              :rows="2"
              placeholder="请输入备注"
              maxlength="20"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <div style="float: right">
            <el-button
              type="primary"
              icon="el-icon-circle-plus-outline"
              @click="saveRecord"
              size="small"
            >
              保存
            </el-button>
            <el-button icon="el-icon-circle-close" @click="cancleRecord" size="small">
              取消
            </el-button>
          </div>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import { nodeTreeByParentId, loadCarPayAmount } from '@/api/v4ward/carv2/carmonth';
import {
  carMonthRuleV2,
  getSpaceList,
  isCarMonth,
  quickAdd,
} from '@/api/v4ward/carv2/carmonthquickRegistration';
import { getDictionary } from '@/api/common.js';
import { monthChargeRuleList, monthChargeRuleListV2 } from '@/api/v4ward/carv2/carmonthchargerule';
import { initEndTime } from '@/api/v4ward/carv2/carmonthchargerule';
export default {
  props: ['value'],
  data() {
    return {
      regionList: [],
      treeRegionProps: {
        labelText: '标题',
        label: 'title',
        value: 'id',
        children: 'children',
      },
      carTypeList: [], //车辆类型
      carCategoryList: [], //车辆类别
      ruleList: [], //收费套餐
      discountRuleList: [], //优惠规则
      cycleNumList: [], //续租时长,
      spaceList: [], //车场
      carRuleDisabled: true,
      discountRuleDisabled: true,
      formRules: {
        spaceId: [{ required: true, message: '车场不能为空', trigger: 'blur' }],
        carNo: [
          { required: true, message: '车牌不能为空', trigger: 'blur' },
          {
            required: true,
            pattern: this.$validation.carPlate,
            message: '车牌格式不对',
            trigger: 'blur',
          },
        ],
        regions: [{ required: true, message: '区域不能为空', trigger: 'blur' }],
        customerName: [{ required: true, message: '客户姓名不能为空', trigger: 'blur' }],
        customerPhone: [
          { required: true, message: '客户手机不能为空', trigger: 'blur' },
          {
            required: true,
            pattern: this.$validation.phone,
            message: '请输入正确的手机号',
            trigger: 'change',
          },
        ],
        driverType: [{ required: true, message: '车辆类别不能为空', trigger: 'blur' }],
        carType: [{ required: true, message: '车辆类型不能为空', trigger: 'blur' }],
        ruleId: [{ required: true, message: '收费套餐不能为空', trigger: 'blur' }],
        buyStartTime: [{ required: true, message: '租赁起期不能为空', trigger: 'blur' }],
        cycleNum: [{ required: true, message: '续租时长不能为空', trigger: 'blur' }],
      },
    };
  },
  created() {
    console.log('快速注册', this.value);
    this.initData();
  },
  methods: {
    discountIdChange() {
      this.computeMoney();
    },
    buyStartTimeChange() {
      this.computeMoney();
      this.getEndTime();
    },
    ruleIdChange() {
      this.value.discountId = '';
      if (this.value.cycleNum && this.value.ruleId) {
        this.discountRuleDisabled = false;
        this.getDiscountList();
      }
      this.computeMoney();
    },
    cycleNumChange() {
      this.value.discountId = '';
      this.getEndTime();
      if (this.value.cycleNum && this.value.ruleId) {
        this.discountRuleDisabled = false;
        this.getDiscountList();
      }
      this.computeMoney();
    },
    driverTypeChange() {
      this.value.ruleId = '';
      this.value.discountId = '';
      if (this.value.carType && this.value.driverType) {
        this.carRuleDisabled = false;
        this.getCarRule();
      }
    },
    carTypeChange() {
      this.value.ruleId = '';
      this.value.discountId = '';
      if (this.value.carType && this.value.driverType) {
        this.carRuleDisabled = false;
        this.getCarRule();
      }
    },
    carNoBlur() {
      isCarMonth({
        spaceId: this.value.spaceId,
        carNo: this.value.carNo,
      });
    },
    initData() {
      this.getSpaceList();
      this.getRegion(this.value.spaceId);
      this.getCarCategory();
      this.getCarType();
      this.getCycleNumList();
    },
    getSpaceList() {
      getSpaceList().then((res) => {
        this.spaceList = res.data;
      });
    },
    //获取区域
    getRegion(id) {
      nodeTreeByParentId(id).then((res) => {
        this.regionList = res.data;
      });
    },
    //获取车辆类别(车主类别)
    getCarCategory() {
      getDictionary('car_category_v2').then((res) => {
        this.carCategoryList = res.data;
      });
    },
    //车辆类型
    getCarType() {
      getDictionary('car_type_v2').then((res) => {
        this.carTypeList = res.data;
      });
    },
    //获取续租时长
    getCycleNumList() {
      getDictionary('car_month_package').then((res) => {
        this.cycleNumList = res.data;
      });
    },
    //获取收费套餐
    getCarRule() {
      this.carRuleDisabled = true;
      monthChargeRuleListV2(
        Object.assign({
          spaceId: this.value.spaceId,
          carType: this.value.carType,
          carCategory: this.value.driverType,
        })
      ).then(({ data }) => {
        this.ruleList = data;
        this.carRuleDisabled = false;
      });
    },
    //获取优惠规则
    getDiscountList() {
      this.discountRuleDisabled = true;
      carMonthRuleV2({
        spaceId: this.value.spaceId,
        payPeriods: this.value.cycleNum,
        chargeRuleId: this.value.ruleId,
      }).then((res) => {
        this.discountRuleList = res.data;
        this.discountRuleDisabled = false;
      });
    },
    //获取止期
    getEndTime() {
      if (this.value.cycleNum && this.value.buyStartTime) {
        initEndTime(
          Object.assign({
            cycleNum: this.value.cycleNum,
            startTime: this.value.buyStartTime,
          })
        ).then(({ data }) => {
          if (data) {
            this.value.buyEndTime = data.endTime;
          }
        });
      }
    },
    //算钱
    computeMoney() {
      console.log('aaa');

      if (this.value.ruleId != '' && this.value.cycleNum != '' && this.value.buyStartTime) {
        loadCarPayAmount({
          ruleId: this.value.ruleId,
          discountId: this.value.discountId,
          cycleNum: this.value.cycleNum,
          startTime: this.value.buyStartTime,
          backAmount: 0,
          backType: 3,
        }).then((res) => {
          this.value.shouldMoney = res.data.shouldAmount;
          this.value.cutMoney = res.data.cutAmount;
          this.value.payMoney = res.data.payAmount;
        });
      }
    },
    saveRecord() {
      this.$refs['formRef'].validate((valid) => {
        if (valid) {
          this.value.buyEndTime = this.dayjs(this.value.buyEndTime).format('YYYY-MM-DD 23:59:59');
          this.value.regions = this.value.regions.join(',');
          quickAdd(this.value).then((res) => {
            this.$message.success('新增成功');
            this.$emit('success');
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    cancleRecord() {
      console.log('触发关闭');
      this.$confirm('是否关闭继续？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.$emit('cancle');
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          });
        });
    },
  },
};
</script>
<style scoped>
::v-deep .el-col-8 {
  height: 54px;
}
</style>
